/**
 * Fetches user activity from GET /api/admin/users/:userId/activity.
 * No cache (staleTime=0, gcTime=0), refetch on mount.
 */
import { useNoCacheQuery } from './useNoCacheQuery';
import {
  fetchUserActivity,
  type UserActivityResponse,
} from '../services/userManagementService';

export function useUserActivity(
  userId: string | undefined,
  params: { page?: number; limit?: number; search?: string } = {}
) {
  const { page = 1, limit = 20, search = '' } = params;
  return useNoCacheQuery<
    {
      data: UserActivityResponse['data'];
      pagination: UserActivityResponse['pagination'];
    },
    Error
  >({
    queryKey: ['user', userId, 'activity', page, limit, search],
    queryFn: async () => {
      if (!userId) throw new Error('userId required');
      const res = await fetchUserActivity(userId, { page, limit, search });
      if (!res.success) throw new Error('Failed to load activity');
      return { data: res.data, pagination: res.pagination };
    },
    enabled: !!userId,
  });
}
